import { useAgentHealth } from '../hooks/useAgentHealth';

function fmt(dt) {
  if (!dt) return '–';
  try { return new Date(dt).toLocaleString('de-DE', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }); } catch { return '–'; }
}

export default function Systemstatus() {
  const { data, isLoading, isFetching, refetch } = useAgentHealth();
  const s = data?.summary;

  return (
    <div className="p-4 lg:p-6 max-w-4xl mx-auto">
      <div className="flex items-start justify-between gap-4 mb-5">
        <div>
          <h1 className="text-[22px] font-semibold tracking-tight text-[#0D3B50]">Systemstatus</h1>
          <p className="text-[13.5px] text-gray-500 mt-1">Überwacht alle Agenten & Datenquellen über alle Projekte. Letzter Check: {fmt(data?.checked_at)}</p>
        </div>
        <button onClick={() => refetch()} disabled={isFetching} className="text-[13px] px-3.5 py-2 border border-gray-200 rounded-lg hover:bg-gray-50 disabled:opacity-50">
          {isFetching ? 'Prüfe…' : 'Aktualisieren'}
        </button>
      </div>

      {isLoading ? (
        <div className="text-[13px] text-gray-500 p-6">Lade…</div>
      ) : s?.ok ? (
        <div className="bg-white rounded-xl border border-black/[.07] p-8 text-center">
          <div className="text-[28px] mb-1">✅</div>
          <div className="text-[15px] font-semibold text-[#2d7d6f]">Alles in Ordnung</div>
          <div className="text-[12.5px] text-gray-500 mt-1">Keine fehlgeschlagenen Agenten, keine Datenquellen-Fehler, keine überfälligen Läufe.</div>
        </div>
      ) : (
        <div className="space-y-5">
          <div className="flex flex-wrap gap-2">
            <Stat label="Fehlgeschlagen" value={s?.failed} color="#dc2626" />
            <Stat label="Datenquellen-Fehler" value={s?.integration_errors} color="#b8860b" />
            <Stat label="Überfällig" value={s?.stale} color="#6b7280" />
          </div>

          <Section title="Fehlgeschlagene Agenten" color="#dc2626" rows={data?.failed_agents} render={(r) => (
            <>
              <div className="flex-1 min-w-0"><span className="font-medium text-gray-800">{r.project}</span> · {r.agent}
                {r.error && <div className="text-[11.5px] text-red-600 mt-0.5">{r.error}</div>}
              </div>
              <span className="text-[11px] text-gray-400 shrink-0">{fmt(r.last_run_at)}</span>
            </>
          )} />

          <Section title="Datenquellen-Fehler" color="#b8860b" rows={data?.integration_errors} render={(r) => (
            <div className="flex-1 min-w-0"><span className="font-medium text-gray-800">{r.project}</span> · {r.type}
              {r.error && <div className="text-[11.5px] text-amber-700 mt-0.5">{r.error}</div>}
            </div>
          )} />

          <Section title="Überfällige Läufe (Automatik prüfen)" color="#6b7280" rows={data?.stale_agents} render={(r) => (
            <>
              <div className="flex-1 min-w-0"><span className="font-medium text-gray-800">{r.project}</span> · {r.agent}</div>
              <span className="text-[11px] text-gray-400 shrink-0">fällig seit {fmt(r.overdue_since)}</span>
            </>
          )} />
        </div>
      )}
    </div>
  );
}

function Stat({ label, value, color }) {
  return (
    <div className="bg-white rounded-lg border border-black/[.06] px-3.5 py-2">
      <div className="text-[18px] font-semibold tabular-nums leading-none" style={{ color }}>{value ?? '–'}</div>
      <div className="text-[10.5px] uppercase tracking-wider text-gray-400 mt-1">{label}</div>
    </div>
  );
}

function Section({ title, color, rows, render }) {
  if (!rows || rows.length === 0) return null;
  return (
    <section>
      <div className="flex items-center gap-2 mb-2">
        <span className="w-2 h-2 rounded-full" style={{ backgroundColor: color }} />
        <h2 className="text-[13px] font-semibold text-[#0D3B50]">{title}</h2>
        <span className="text-[11.5px] text-gray-400">{rows.length}</span>
      </div>
      <div className="bg-white rounded-xl border border-black/[.07] divide-y divide-gray-100">
        {rows.map((r, i) => <div key={i} className="flex items-start gap-3 px-4 py-2.5 text-[12.5px] text-gray-700">{render(r)}</div>)}
      </div>
    </section>
  );
}
